export default "__VITE_ASSET__CD6KceK9__"